import { render, staticRenderFns } from "./CriterionDeleter.vue?vue&type=template&id=aaae81d6&scoped=true"
import script from "./CriterionDeleter.vue?vue&type=script&lang=ts"
export * from "./CriterionDeleter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaae81d6",
  null
  
)

export default component.exports